import { isWordProcessorHtmlEqual } from "components/word-processor-field/word-processor-value.utils";

export type SyncContextApplyAction = "apply" | "pending" | "noop";

export function resolveSyncContextApplyAction(
  isDirty: boolean,
  currentContext: string,
  syncedContext: string,
  isEqual: (a: string, b: string) => boolean = isWordProcessorHtmlEqual
): SyncContextApplyAction {
  if (isEqual(currentContext, syncedContext)) {
    return "noop";
  }
  if (!isDirty) {
    return "apply";
  }
  return "pending";
}
